var map = {
	"./000---StartSword.json": 33965,
	"./001---AdminWeapon.json": 9474,
	"./002---QuickSword.json": 1192,
	"./003---RevengeSword.json": 95739,
	"./004---BleedCrit.json": 18471,
	"./005---OilSword.json": 55398,
	"./006---Burner.json": 5321,
	"./007---DualDaggers.json": 67620,
	"./008---BackStabber.json": 7221,
	"./009---LowHealth.json": 71957,
	"./010---Bleeder.json": 23857,
	"./011---BroadSword.json": 35405,
	"./012---Shovel.json": 61327,
	"./013---EvilSword.json": 78003,
	"./014---SpeedBlade.json": 95486,
	"./015---GiantKiller.json": 42202,
	"./016---BulletBlade.json": 20517,
	"./017---SismicBlade.json": 41154,
	"./018---StunMace.json": 62318,
	"./019---BumpBoots.json": 39223,
	"./020---SpikedBoots.json": 70819,
	"./021---MultiKickBoots.json": 92821,
	"./022---QuickFists.json": 57790,
	"./023---Spear.json": 94802,
	"./024---ImpaleSpear.json": 5246,
	"./025---KingsSpear.json": 95385,
	"./026---Rapier.json": 59044,
	"./027---PerfectHalberd.json": 55282,
	"./028---BehemothHammer.json": 9809,
	"./029---DashSword.json": 36075,
	"./030---Whip.json": 37310,
	"./031---HookWhip.json": 74867,
	"./032---TentacleWhip.json": 82669,
	"./033---Pan.json": 89207,
	"./034---MachetePistol.json": 34117,
	"./035---HardLightSword.json": 61388,
	"./036---HardLightGun.json": 80487,
	"./037---ParryBlade.json": 34987,
	"./038---TickScytheLeft.json": 44250,
	"./039---TickScytheRight.json": 49069,
	"./040---RhythmicBlade.json": 92525,
	"./041---Crowbar.json": 1805,
	"./042---SnakeFang.json": 63695,
	"./043---GiantStaff.json": 72873,
	"./044---Lantern.json": 72753,
	"./045---LanternOffHand.json": 93474,
	"./046---FlyingSword.json": 89654,
	"./047---NotFlyingSword.json": 50498,
	"./048---Tombstone.json": 22135,
	"./049---HeavyAxe.json": 89209,
	"./050---Club.json": 98195,
	"./051---ClubBroken.json": 36202,
	"./052---PureNail.json": 29007,
	"./053---SkulBone.json": 87133,
	"./054---StartBow.json": 37094,
	"./055---DualBow.json": 58162,
	"./056---InfiniteBow.json": 78033,
	"./057---LongBow.json": 23389,
	"./058---SonicCrossbow.json": 78773,
	"./059---CloseCombatBow.json": 80868,
	"./060---FastBow.json": 59015,
	"./061---FrostBow.json": 26854,
	"./062---CrossBow.json": 36435,
	"./063---CrossBowOffHand.json": 9030,
	"./064---MultiCrossBow.json": 30000,
	"./065---MultiCrossBowOffHand.json": 19177,
	"./066---FrostCrossBow.json": 81838,
	"./067---FrostCrossBowOffHand.json": 34998,
	"./068---ExplosiveCrossBow.json": 23197,
	"./069---ExplosiveCrossBowOffHand.json": 76620,
	"./070---AlchemicGun.json": 40222,
	"./071---MarkBow.json": 64057,
	"./072---PreciseBow.json": 89422,
	"./073---ThrowingKnife.json": 38406,
	"./074---Boomerang.json": 40231,
	"./075---BleedAxe.json": 69269,
	"./076---GodAxe.json": 22488,
	"./077---ThrowingSpear.json": 40230,
	"./078---Blowgun.json": 55373,
	"./079---MagicBow.json": 39663,
	"./080---StartShield.json": 31564,
	"./081---WarriorShield.json": 22213,
	"./082---Shield.json": 64634,
	"./083---AreaShield.json": 96313,
	"./084---BumpShield.json": 20474,
	"./085---Rampart.json": 2839,
	"./086---GreedShield.json": 4283,
	"./087---DashShield.json": 35682,
	"./088---BloodShield.json": 83836,
	"./089---SpikeShield.json": 57741,
	"./090---ParryShield.json": 71762,
	"./091---HoldShield.json": 8723,
	"./092---ThunderShield.json": 33979,
	"./093---IceShield.json": 42609,
	"./094---MagicSalve.json": 40483,
	"./095---FireBall.json": 2079,
	"./096---Lightning.json": 66142,
	"./097---LightningWhip.json": 85650,
	"./098---FlameThrower.json": 50054,
	"./099---ThrowingTorch.json": 51242,
	"./100---ThrowingIce.json": 89992,
	"./101---Freeze.json": 86538,
	"./102---BarrelLauncher.json": 22081,
	"./103---Katana.json": 47922,
	"./104---Trident.json": 74234,
	"./105---ThrowingCards.json": 4965,
	"./106---HandHook.json": 75250,
	"./107---Shark.json": 81843,
	"./108---ElbowBlades.json": 32969,
	"./109---HeavyBow.json": 27167,
	"./110---WreckingBall.json": 19925,
	"./111---QueenRapier.json": 76543,
	"./112---CupidityDagger.json": 42958,
	"./113---GoldDigger.json": 19335,
	"./114---MoneyShooter.json": 17204,
	"./115---KingScepter.json": 74149,
	"./116---BaseballBat.json": 74298,
	"./117---ThrowableStuff.json": 89056,
	"./118---LaserGlaive.json": 40784,
	"./119---Starfury.json": 30619,
	"./120---HydraSpell.json": 86323,
	"./121---NunchuckPan.json": 81788,
	"./122---Cross.json": 5822,
	"./123---TPSword.json": 96947,
	"./124---ThrowingAxe.json": 31123,
	"./125---WiggleWhip.json": 50041,
	"./126---Bible.json": 82505,
	"./127---SnakeSwordWeapon.json": 19699,
	"./128---SnakeSwordWeaponAlt.json": 86570,
	"./129---SnakeSwordSwap.json": 93789,
	"./130---VampireKiller.json": 10989,
	"./131---AlucardShield.json": 33940,
	"./132---MedusaHead.json": 95337,
	"./133---AdeleScythe.json": 74434,
	"./134---RichterVampireKiller.json": 71663,
	"./135---CombinedTickScythe.json": 52134,
	"./136---Pistol.json": 64713,
	"./137---Scissor.json": 41839,
	"./138---Comb.json": 21376,
	"./__PROPS__.json": 9786,
	"./__STRUCTURE__.json": 23730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50174;